import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Cr02DialogComponent } from './cr02-dialog/cr02-dialog.component';

@NgModule({
  declarations: [Cr02DialogComponent],
  imports: [CommonModule, FormsModule],
  exports: [Cr02DialogComponent]
})
export class SharedModule {}
